import { useMemo } from 'react';

import { useGET } from '../shared/hooks';

const toUrl = gameId => `/stats/game/${gameId}/shotcharts`;

export function useShotCharts(gameId) {
  const data = useGET(toUrl(gameId));

  return useMemo(() => data && data.charts, [data]);
}
